import {NgModule} from '@angular/core';
import {ConfirmationDialogComponent} from './confirmation-dialog.component';
import {CommonModule} from '@angular/common';
import {ButtonModule} from '../../custom-components/button/button.module';
import {SafeHtmlSanitizerModule} from '../../pipes/safe-html-sanitizer/safe-html-sanitizer.module';
import { DatePickerModule } from '../../custom-components/date-picker/date-picker.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
	declarations: [ConfirmationDialogComponent],
	imports: [
		CommonModule, 
		ButtonModule, 
		SafeHtmlSanitizerModule, 
		DatePickerModule, 
		TranslateModule,
		ReactiveFormsModule,
		FormsModule],
	exports: [ConfirmationDialogComponent]
})

export class ConfirmationDialogModule {
}
